import { translate } from "@/i18n/format";
import type { MessageKey } from "@/i18n/catalogs";

const RATE_LIMIT_CODES = new Set(["auth/quota-exceeded", "auth/too-many-requests"]);

function authErrorCode(error: unknown): string | null {
  if (error && typeof error === "object" && "code" in error && typeof (error as { code: unknown }).code === "string") {
    return (error as { code: string }).code.toLowerCase();
  }
  if (error instanceof Error) {
    const match = error.message.match(/auth\/[a-z0-9-]+/i);
    return match ? match[0].toLowerCase() : null;
  }
  return null;
}

function mentionsInternalProvider(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return /firebase|auth\/[a-z0-9-]+/i.test(error.message);
}

export function messageForSignInError(
  error: unknown,
  fallback: string,
  t: (key: MessageKey) => string = (key) => translate("en", key),
): string {
  const code = authErrorCode(error);
  if (code && RATE_LIMIT_CODES.has(code)) {
    return t("login.err.rateLimit");
  }
  if (code === "auth/invalid-email") return t("login.invalidEmail");
  if (code === "auth/network-request-failed") {
    return t("login.err.network");
  }
  if (code === "auth/popup-closed-by-user" || code === "auth/cancelled-popup-request") {
    return t("login.err.cancelled");
  }
  if (code === "auth/popup-blocked") return t("login.err.popupBlocked");
  if (code === "auth/invalid-action-code" || code === "auth/expired-action-code") {
    return t("login.invalidLink");
  }
  if (error instanceof Error && error.message && !mentionsInternalProvider(error)) {
    return error.message;
  }
  return fallback;
}
